import { all, takeEvery, fork, put } from "redux-saga/effects";
import axios from "axios";

import actions from "./actions";
import { Utils } from "../../resources/util";

let headers = { headers: { "Content-Type": "application/json" }, withCredentials: true };

export function* getBenefitsAndPayments() {
  yield takeEvery(actions.GET_BENEFITS_AND_PAYMENTS, function*(dataObj) {
    try {
      const response = yield axios.get(
        `${Utils.getBaseApiUrl()}/estimations/bundle?state=${dataObj.data.stateCode}&smartHome=${dataObj.data.smartHome}&solar=${
          dataObj.data.solar
        }&battery=${dataObj.data.battery}&annualBillAmount=${dataObj.data.annualBill}&deposit=${dataObj.data.deposit}&householdSize=${
          dataObj.data.householdSize
        }&hasSolar=${dataObj.data.hasSolar}&hasBattery=${dataObj.data.hasBattery}&hasPool=${dataObj.data.hasPool}&wasteFactor=${
          dataObj.data.wasteFactor
        }`,
        headers
      );
      if (response.status === 200 || response.status === 201) {
        yield put({
          type: actions.GET_BENEFITS_AND_PAYMENTS_SUCCESS,
          response
        });
      } else {
        yield put({
          type: actions.GET_BENEFITS_AND_PAYMENTS_ERROR,
          response
        });
      }
    } catch (error) {
      yield put({
        type: actions.GET_BENEFITS_AND_PAYMENTS_ERROR,
        error
      });
    }
  });
}

export default function* rootSaga() {
  yield all([fork(getBenefitsAndPayments)]);
}
